// import { User } from "@/models/user";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProgressState } from "@/types/progress";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Module } from "vuex";
import { Progress } from "@/models/progress";

const state: ProgressState = {
  single: new Progress(),
  pagination: new Pagination(),
};

export const progress: Module<ProgressState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
